import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class LuC21LocationIdAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-c21-location-id';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/c21s/locations/ids';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'id',
      'name',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return [
    ];
  }

}

export default LuC21LocationIdAppResource;
